module.exports = __webpack_public_path__ + "img/perforaciones_16-9_960.0341f8cc.jpg";